export const common = {
  agent: "AI",
  general: "GENERAL",
  group: "GROUP",
  individual: "INDIVIDUAL",
};

export const sideNav = {
  Chat: "CHAT",
  Notes: "NOTES",
  QA: "QA",
  About: "ABOUT",
  JobDescription: "JOB_DESCRIPTION",
  Effects: "effects"
};

export const haveToUseDeepgramForAiInterview = false;
